import { render, staticRenderFns } from "./UserProductInfo.vue?vue&type=template&id=f3faf480&"
import script from "./UserProductInfo.vue?vue&type=script&lang=js&"
export * from "./UserProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports